import { useVerticalStepMarkerContainerProps, useVerticalStepContainerProps } from '../useVerticalStep.js';
import { getTrackProgress, getTrackSize, getMarkerVerticalSpacing } from '../../../../helpers/Step.helpers.js';

var useProgressionVerticalStep = function useProgressionVerticalStep(props) {
  var state = props.state,
    progress = props.progress,
    size = props.size,
    markerContent = props.markerContent,
    startSlot = props.startSlot,
    endSlot = props.endSlot;
  return {
    stepContainerProps: useVerticalStepContainerProps(),
    markerContainerProps: useVerticalStepMarkerContainerProps(size, !!startSlot, !!endSlot),
    markerProps: {
      state: state,
      size: size,
      content: markerContent,
      mb: getMarkerVerticalSpacing(size)
    },
    trackProps: {
      direction: 'vertical',
      size: getTrackSize(size),
      progress: getTrackProgress('progression', state, progress)
    }
  };
};

export { useProgressionVerticalStep };
//# sourceMappingURL=useProgressionVerticalStep.js.map
